module.exports = __webpack_public_path__ + "img/cloud-3.84e6c0dd.svg";